import { render } from "./ObjectOptions.vue?vue&type=template&id=f825c518"
import script from "./ObjectOptions.vue?vue&type=script&lang=js"
export * from "./ObjectOptions.vue?vue&type=script&lang=js"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__